// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1323":"4d77d56e97c44557","1454":"888916cb0ef84c50"}[chunkId] + ".js";
};